<template>
  <div>
    <!-- <div v-if="focus && focus.state && focus.state==='ontrack'">
        ONTRACK
      <template v-slot:ontrack>
        ONTRACK
      </template>
    </div>
    <div v-else-if="focus && focus.state && focus.state==='ondeck'">
        ondeck
      <template v-slot:ondeck>
        ondeck
      </template>
    </div>  
    <div v-else-if="focus && focus.state && focus.state==='stationed'">
        stationed
      <template v-slot:stationed>
        stationed
      </template>
    </div> -->

      <div v-if="focus && focus.state == 'ontrack'">
        <div style="display:flex">

          <div>
            <div>
              <div style="display:flex">
                <div>
                <textarea
                        class="notepad"
                        v-model="noteForLogger"
                        placeholder="Enter text here ..." />
                </div>
              </div>
              <div style="display:flex">
                <div style="display:flex; justify-content: center">
                  <button @click="handleClickLogger(tool)">Enter</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div v-else-if="focus && focus.state == 'ondeck'">
        <div style="display:flex">
          <div>
            Settings:
            <hr />
            <p>Share Entries with  &lt;C&gt;rew</p>
          </div>
        </div>
      </div>


      <div v-else-if="focus && focus.state == 'stationed'" style="width: 100%">
        <div style="display:flex; width: 100%">
          <!-- <canvas :id="tool.text"></canvas> -->
          <div v-if = "tool && tool.settings && tool.settings.type =='logger' && tool.tracks">
            <div style="display:flex; margin-top: 0.5rem" v-for="(note,i) in tool.tracks" :key="i">
              <div class="notepad">
                {{note.text}}
              </div>
            </div>
          </div>
        </div>
      </div>


      <div v-else>
        <div style="display:flex">
          <div>
            SPLASH: INVALID STATE
          </div>
        </div>
      </div>
    
  </div>
</template>
<script>

export default {
  name: 'journal-web-component-raw',
  components: {
  },
  props: {
    tool: {
      type: Object,
      required: false,
      default:()=>{}
    },
    focus: {
      type: Object,
      required: false,
      default: () => {
      }
    },
    user: {
      type: String,
      required: false,
      default: () => ""
    },
    typeaheadApps: {
      type: Array,
      default: () => ['Maps','Calculator']
    },
    setTracker: {
      type: Function,
      default: () => () => {}
    },
  },
  methods:{
    handleClickLogger(tool) {
      let updatedTool;
      this.checkInAt = new Date();
      if(tool.tracks) {
        updatedTool = {...tool, tracks: [...tool.tracks, {text: this.noteForLogger, _created_at: this.checkInAt }]}
      } else {
        updatedTool = {...tool, tracks: [{text: this.noteForLogger, _created_at: this.checkInAt}]}
      }
      // this.$store.dispatch('tools/setTrackerInTool', {focusId: this.focus.focusId, userUid: this.user.uid, tool: updatedTool }).then(() => this.noteForLogger = "")
      this.setTracker({focusId: this.focus.focusId, userUid: this.user, tool: updatedTool }).then(() => this.noteForLogger = "")
    },
    setSettings() {
      this.showModalAppStore = true;
    },
    handleStoreClick() {
        this.showModalAppStore = true;
    },
    fillData () {
      this.datacollection = {
        labels: [this.getRandomInt(), this.getRandomInt()],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [this.getRandomInt(), this.getRandomInt()]
          }, {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [this.getRandomInt(), this.getRandomInt()]
          }
        ]
      }
    },
    getRandomInt () {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    }
  },
  computed: {
    toolsetting: {
      set: function(val) {
        this.A.a = val;
      },
      get: function() {
        return this.A.a
      }
    },
  },
  data: function() {
    return {
      showTracking: false,
      checkInAt: null,
      showModalAppStore: false,
      selectedAppConnection: null,
      defaultTool: this.tool && this.tool.settings && this.tool.settings.type ? this.tool.settings.type : "" ,
      noteForLogger: "",
      datacollection: null
    }
  },
  mounted(){
    // this.fillData()
  }
}
</script>
<style lang="scss" module>
  @import './style.module.scss';
</style>
<style scoped>
  .notepad {
    background-color: rgb(255, 242, 204);
    border-radius: 5px;
    width: 100%;
    height: 125px;
  }
  .card-body {
    overflow-y: auto;
  }
</style>
<style lang="scss">  
  /* @import "../../../node_modules/bootstrap-css-only/css/bootstrap.min.css"; */
</style>
